/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { countryCodes } from '@/constants/locale';
import type { Locale } from '@/types/i18n';

const FIRST_PATH_COMPONENT = /(^\/[^/]*)/;

export const blogPrefix: Record<Locale, string> = {
  [countryCodes.enUS]: '/diy',
  [countryCodes.mx]: '/expertips',
  [countryCodes.ptBr]: '/blog',
};

export function isValidBlogLocale(path: string, locale: Locale): boolean {
  const root = FIRST_PATH_COMPONENT.exec(path)?.[0];
  return Boolean(root && root === blogPrefix[locale]);
}
